'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dPolicy$002dPage$0024 from "./presto.-Edit-Policy-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459 from "./presto.-Presto-Router$$anon$59.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$58() {
  this.blu = null;
  this.blm = null;
  this.bln = false;
  this.blv = null;
  this.blw = false;
  this.blz = null;
  this.bls = null;
  this.blt = false;
  this.blo = null;
  this.blp = false;
  this.blq = null;
  this.blr = false;
  this.blx = false;
  this.bly = false;
  this.blu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.blz = "EditPolicyPage";
}
export { $c_Lpresto_PrestoRouter$$anon$58 as $c_Lpresto_PrestoRouter$$anon$58 };
$p = $c_Lpresto_PrestoRouter$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$58;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$58() {
}
export { $h_Lpresto_PrestoRouter$$anon$58 as $h_Lpresto_PrestoRouter$$anon$58 };
$h_Lpresto_PrestoRouter$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.blu;
});
$p.M = (function() {
  if ((!this.bln)) {
    this.blm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bln = true;
  }
  return this.blm;
});
$p.O = (function() {
  if ((!this.blw)) {
    this.blv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blw = true;
  }
  return this.blv;
});
$p.D = (function() {
  return this.blz;
});
$p.t = (function() {
  if ((!this.blt)) {
    this.bls = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.blt = true;
  }
  return this.bls;
});
$p.N = (function() {
  if ((!this.blp)) {
    this.blo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().Ti(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.blp = true;
  }
  return this.blo;
});
$p.Q = (function() {
  if ((!this.blr)) {
    this.blq = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459.$c_Lpresto_PrestoRouter$$anon$59();
    this.blr = true;
  }
  return this.blq;
});
$p.v = (function() {
  if ((!this.bly)) {
    this.blx = false;
    this.bly = true;
  }
  return this.blx;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee437) => ((p) => \u03b4scrutinee437.cH0(p)))($j_presto$002e$002dEdit$002dPolicy$002dPage$0024.$m_Lpresto_EditPolicyPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$58, "presto.PrestoRouter$$anon$58", ({
  Oy: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$58 as $d_Lpresto_PrestoRouter$$anon$58 };
//# sourceMappingURL=presto.-Presto-Router$$anon$58.js.map
